
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoAvMbGrid extends Serenity.EntityGrid<PsPromoAvMbRow, any> {
        protected getColumnsKey() { return PsPromoAvMbColumns.columnsKey; }
        protected getDialogType() { return PsPromoAvMbDialog; }
        protected getIdProperty() { return PsPromoAvMbRow.idProperty; }
        protected getInsertPermission() { return PsPromoAvMbRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPromoAvMbRow.localTextPrefix; }
        protected getService() { return PsPromoAvMbService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}